import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from '../../utils/auth'

export default (store) => ({
  path: 'campaign',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CampaignContainer = require('./containers/Campaign').default
      const reducer = require('./modules/campaign').default
      let homeReducers = require('../Home/modules/home')

      /*  Add the reducer to the store on key 'counter'  */
      const loadStoreOptionsReducer = homeReducers.loadStoreOptionsReducer
      const filterValuesReducer = homeReducers.filterValuesReducer
      injectReducer(store, {key: 'campaign', reducer: reducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      /*  Return getComponent   */
      cb(null, CampaignContainer)

      /* Webpack named bundle   */
    }, 'campaign')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Campaign/index.js